import { Dropdown } from 'front-commons/ds/components/Dropdown';
import { FidelityBox } from 'front-commons/ds/components/FidelityBox';
import { Flex } from 'front-commons/ds/components/Flex';
import { Icon } from 'front-commons/ds/components/Icon';
import { Skeleton } from 'front-commons/ds/components/Skeleton';
import { useHeader } from '../../../../context';
import { useHeaderBoni } from './hooks/useHeaderBoni';
import { Trigger } from './components/Trigger';

export function HeaderBoni() {
	const {
		fidelity: fidelityControls,
		pharmacy: { loadingPos },
		tracking: { selectContentGTM },
	} = useHeader();

	const { expanded, setExpanded, medium, OverlayComponent, handleButtonNavigate } = useHeaderBoni({ selectContentGTM });

	if (!medium) return <></>;

	if (medium && (loadingPos || fidelityControls.store.loading)) {
		return (
			<Flex display="flex" gap="0.5rem" alignItems="center">
				<Icon name="boniLogo" size="24px" sizeIgnoreHeight color="--boni-purple700" />
				<Flex display="flex" gap="0.25rem" direction="column">
					<Skeleton height="14px" width="100px" />
					<Skeleton height="14px" width="120px" />
				</Flex>
			</Flex>
		);
	}

	return (
		<>
			<Dropdown
				align="center"
				colorButton="--boni-purple700"
				expanded={expanded}
				mobileFull
				offset={4}
				onOpenChange={() => setExpanded((prevState) => !prevState)}
				radiusFullDesktop
				triggerContent={<Trigger {...fidelityControls.store.data} onClick={fidelityControls?.onClick} />}
				useExpanded
				disabled={!!fidelityControls?.onClick}
			>
				<Flex maxWidth="392px">
					<FidelityBox
						data={fidelityControls.store.data}
						onGoToBoni={handleButtonNavigate}
						waitingToken={fidelityControls.store.loadingToken}
					/>
				</Flex>
			</Dropdown>

			<OverlayComponent />
		</>
	);
}
